import InfoModal from './InfoModal';
import './InfoModal.scss';

export default InfoModal;
